import type { ReactNode, CSSProperties } from "react";

export interface CardProps {
  title?: string;
  subtitle?: string;
  rightSlot?: ReactNode;
  children: ReactNode;
  onClick?: () => void;
  padding?: number | string;
  style?: CSSProperties;
}

export function Card({
  title,
  subtitle,
  rightSlot,
  children,
  onClick,
  padding,
  style,
}: CardProps) {
  const clickable = !!onClick;
  return (
    <div
      onClick={onClick}
      style={{
        background: "var(--surface-card)",
        border: "1px solid var(--border-default)",
        borderRadius: "var(--radius-card)",
        boxShadow: "var(--shadow-card)",
        padding: padding ?? "var(--space-card-pad)",
        cursor: clickable ? "pointer" : "default",
        transition: "box-shadow 0.15s ease",
        ...style,
      }}
      onMouseEnter={(e) => {
        if (clickable) {
          e.currentTarget.style.boxShadow = "var(--shadow-card-hover)";
          e.currentTarget.style.borderColor = "var(--border-glow)";
        }
      }}
      onMouseLeave={(e) => {
        if (clickable) {
          e.currentTarget.style.boxShadow = "var(--shadow-card)";
          e.currentTarget.style.borderColor = "var(--border-default)";
        }
      }}
    >
      {(title || rightSlot) && (
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "baseline",
            marginBottom: 12,
          }}
        >
          <div>
            {title && (
              <div
                style={{
                  fontSize: 12,
                  fontWeight: 600,
                  textTransform: "uppercase",
                  letterSpacing: "0.5px",
                  color: "var(--text-secondary)",
                }}
              >
                {title}
              </div>
            )}
            {subtitle && (
              <div style={{ fontSize: 12, color: "var(--text-muted)", marginTop: 2 }}>
                {subtitle}
              </div>
            )}
          </div>
          {rightSlot && <div>{rightSlot}</div>}
        </div>
      )}
      {children}
    </div>
  );
}
